import Core from "Core";

export class LogsStore extends Core.Stores.ModelStore {
  constructor(modelType, store) {
    super(modelType, "/api/public/logs.php", store);
  }

  beforeUpdateFromJson() {
    this.clear();
  }

  fetchByCustomerId(customerId) {
    return this.fetch(`?customerId=${customerId}`);
  }
}



// WEBPACK FOOTER //
// ./src/Stores/DataStore/LogsStore.js